
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { useRouter } from 'next/router';
import { GetStaticProps, NextPage } from 'next';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import Stack from '@mui/material/Stack';
import FiltersPanel, { Filter, FilterGroup } from 'pages/wiki/filters';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import RightPanel from 'pages/wiki/right-panel';
import HeaderBar from 'components/atomic/organisms/header';
import RoleCard from 'pages/wiki/item-card/role';
import useFilters from 'pages/wiki/use-filters';
import Footer from 'components/atomic/organisms/footer';
import ItemList from 'pages/wiki/item-list';
import Hero from 'pages/wiki/hero';
import Routes, { toAbsoluteUrl } from 'utils/routes';
import { RoleOverview } from 'types/wiki';
import devvSdk from 'utils/devv-sdk';
const SEO = () => {
    const router = useRouter();
    const keywords = [
        'lavoro da remoto',
        'diventare sviluppatore',
        'diventare programmatore',
        'diventare web developer',
        'professioni programmatore',
        'carriere tech',
    ];
    return (<>
            <NextSeo title="Carriere tech e programmazione" titleTemplate={'%s | Devv'} description="Scopri ed esplora le professioni più richieste e più utili nel mondo del tech e programmazione. Conosci i loro ambiti di utilizzo, e quanto vengono retribuite mediamente." canonical={`${toAbsoluteUrl(router.asPath)}`} additionalMetaTags={[
            {
                property: 'keywords',
                content: keywords.join(', '),
            },
        ]} openGraph={{
            url: `${toAbsoluteUrl(router.asPath)}`,
            images: [
                {
                    url: `${toAbsoluteUrl(`/assets/og/wiki-roles.png`)}`,
                    secureUrl: `${toAbsoluteUrl(`/assets/og/wiki-roles.png`)}`,
                    type: 'image/png',
                    width: 1200,
                    height: 630,
                },
            ],
        }}/>
            <BreadcrumbJsonLd itemListElements={[
            {
                position: 1,
                name: 'Wiki',
                item: `${toAbsoluteUrl(Routes.Wiki)}`,
            },
            {
                position: 2,
                name: 'Professioni programmazione',
                item: `${toAbsoluteUrl(Routes.WikiLanguages)}`,
            },
        ]}/>
        </>);
};
interface RolesPageProps {
    roles: RoleOverview[];
    filters: Filter[];
}
const RolesPage: NextPage<RolesPageProps> = (props) => {
    const { addFilter, removeFilter, clearFilters, activeFilters, setSearch, filteredItems } = useFilters(props.roles);
    return (<>
            <SEO />

            <HeaderBar />

            <Hero title="Professioni" description="Scopri ed esplora le professioni più richieste e più utili nel mondo della programmazione. Conosci i loro ambiti di utilizzo, e quanto vengono retribuite mediamente." searchPlaceholder="Cerca una Professione..." onSearch={(s) => setSearch(s)} color="#7f3991"/>

            <ResponsiveContainer maxWidth={'xl'}>
                <Stack direction={'row'}>
                    <FiltersPanel>
                        {props.filters.map((filter, index) => (<FilterGroup key={index} title={filter.title} items={filter.items} activeFilters={activeFilters} onClear={clearFilters} onAdd={addFilter} onRemove={removeFilter}/>))}
                    </FiltersPanel>

                    <ItemList items={filteredItems} count={filteredItems.length} activeFilters={activeFilters} onRemoveFilter={removeFilter} itemColumns={{ xs: 12, md: 6 }} renderItem={(item) => <RoleCard item={item}/>}/>

                    <RightPanel />
                </Stack>
            </ResponsiveContainer>

            <Footer />
        </>);
};
const getStaticProps: GetStaticProps<RolesPageProps> = async () => {
    const { data: domainsOverview } = await devvSdk.getDomainsOverview();
    const { data: rolesOverview } = await devvSdk.getRolesOverview();
    const filters = [
        {
            title: 'Filtra per ambito',
            items: domainsOverview
                .map((domain) => ({
                slug: domain.slug,
                title: domain.title,
                count: rolesOverview.filter((role) => role.categories.includes(domain.slug)).length,
                tags: rolesOverview
                    .filter((role) => role.categories.includes(domain.slug))
                    .map((role) => role.slug),
            }))
                .filter((el) => el.count > 0)
                .sort((a, b) => b.count - a.count),
        },
    ];
    return {
        props: {
            roles: rolesOverview,
            filters,
        },
    };
};
export default RolesPage;

    async function __Next_Translate__getStaticProps__18916ceb2e2__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/wiki/roles/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb2e2__ as getStaticProps }
  